import { Marker } from '@react-google-maps/api'
import React, { FC, useEffect, useState } from 'react'

import { BillboardGeo, LocationPostalCode } from '../../api/interfaces'
import { useGetPostalCodesQuery } from '../../api/rtkQueryApi/platform/targetingApi'

export interface IBillboardMarker {
  billboardGeo: BillboardGeo
  onBillboardPostalCodeClick?: (postalCode: LocationPostalCode) => void
  onQuickBillboardClick?: (billboard: BillboardGeo) => void
  isSelected?: boolean
}
const selectedIcon = 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png'

export const BillboardMarker: FC<IBillboardMarker> = ({ billboardGeo, onBillboardPostalCodeClick, onQuickBillboardClick, isSelected }) => {
  const [hasClicked, setHasClicked] = useState<boolean>(false)
  const postalCodesQuery = useGetPostalCodesQuery({ code: billboardGeo.zipCode }, { skip: !hasClicked })

  useEffect(() => {
    if (postalCodesQuery.data && hasClicked) {
      setHasClicked(false)
      const postalCode = postalCodesQuery.data.find(c => c.code === billboardGeo.zipCode)
      if (postalCode && onBillboardPostalCodeClick) {
        onBillboardPostalCodeClick(postalCode)
      }
    }
  }, [postalCodesQuery, billboardGeo, onBillboardPostalCodeClick, hasClicked])

  const onClick = () => {
    if (onQuickBillboardClick) {
      onQuickBillboardClick(billboardGeo)
    }
    setHasClicked(true)
  }

  return <Marker clickable={!!onBillboardPostalCodeClick} position={{ lat: billboardGeo.latitude, lng: billboardGeo.longitude }} title={`Zip: ${billboardGeo.zipCode}`} onClick={() => onClick()} icon={isSelected ? selectedIcon : undefined} />
}
